"use client";

import { Button } from "@workspace/ui/components/button";
import { SignedIn, SignedOut } from "@clerk/nextjs";
import { useRouter } from "next/navigation";
import Link from "next/link";

// Generate a random 8-character alphanumeric session token
function generateSessionToken(): string {
  const chars =
    "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
  let result = "";
  for (let i = 0; i < 8; i++) {
    result += chars.charAt(Math.floor(Math.random() * chars.length));
  }
  return result;
}

export default function Page() {
  const router = useRouter();

  const handleStartInterview = () => {
    const sessionToken = generateSessionToken();
    router.push(`/interview/${sessionToken}/start`);
  };

  return (
    <div className="flex items-center justify-center min-h-svh">
      <div className="flex flex-col items-center justify-center gap-4">
        <h1 className="text-2xl font-bold">Tellcasey</h1>
        <p className="text-muted-foreground text-center max-w-md">
          Turn every customer win into a sales-ready story without lifting a
          finger.
        </p>

        <SignedOut>
          <div className="flex flex-col items-center gap-4">
            <p className="text-sm text-muted-foreground">
              Sign in to get started
            </p>
            <Link href="/auth/login">
              <Button size="lg">Sign In to Get Started</Button>
            </Link>
          </div>
        </SignedOut>

        <SignedIn>
          <Link href="https://app.tellcasey.com">
            <Button size="lg">Go to Dashboard</Button>
          </Link>
        </SignedIn>
      </div>
    </div>
  );
}
